module.exports = __webpack_public_path__ + "static/media/icon.4a44dac6.svg";